/**
 * @name RootLayout
 * @description Layout raiz da aplicação - wrapper principal com UserProvider e AuthIntegrationMiddleware
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthIntegrationMiddleware from '../../components/middleware/AuthIntegrationMiddleware';
import { UserProvider } from '../../contexts/UserContext/UserContext';

export const RootLayout: React.FC = () => {
     return (
          <UserProvider>
               <AuthIntegrationMiddleware>
                    <Outlet />
               </AuthIntegrationMiddleware>
          </UserProvider>
     );
};
